import React from 'react';
import XHRUploader from "Components/shared/XHRUploader.js"
import { maxFileSize } from "Source/globalFunction";
import { connect } from "react-redux";
import useConfirmPopup from '@/src/components/common/Elements/Modal/useConfirmPopup';
import { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';
import { ACTION_POSITIONS, MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import ModalPortal from '@/src/components/common/Modal/ModalPortal';

let fromDrag = ""
let cxhrs = [];
let totalSize = 0
@connect(store => {
  return {
    conversations: store.conversations,
    screenLoader: store.screenLoader,
  };
})
class CommentUploader extends XHRUploader {
  constructor(props) {
    super(props)
    this.itemList = [];

    this.inserted = false;
    this.docList = [];

    _.map([
      "clearFile",
      "upload",
      "checkFileSupported",
      "handleMaxFileSize",
      "renderFileSet",
      "handleDrops",
      "setIndex",
      "cancelAllUpload",
      "executeCancel"
    ],
      fn => {
        this[fn] = this[fn].bind(this);
      })

  }
  componentDidUpdate(prev) {
    const { conversations } = this.props
    if (!_.isEqual(prev.conversations.isCancel, conversations.isCancel) && conversations.isCancel) {
      this.cancelAllUpload()
    }
    this.displayFileList();
  }
  clearFile() {
    this.itemList = [];
    this.fileInput.value = ''
    totalSize = 0
    this.inserted = false;
    this.docList = []
    this.setState({ items: [], completed: false }, () => {
      this.forceUpdate()
    })
  }

  displayFileList() {
    const { conversations, dispatch } = this.props
    const { files, inserted } = conversations;

    const selectedFiles = files.filter((file) => !file.cancelled);

    if (selectedFiles.length > 0 && !inserted) {
      dispatch({ type: "CONVERSATION_UPLOADED_STATUS", bool: false })
      if ((fromDrag && fromDrag === 'send') || this.props.actionType === "send") {
        $(".text-editor-inner-container").append(`<div id='new' class='insert_upload' style='height:150px'/>`)
        $(".text-editor-inner-container").addClass("uploaderActive");
        $(".conversation-modal .conversation-list.hasScroll").css("max-height", "calc(100vh - 650px)")
      } else {
        $(`<div id='new' class='insert_upload' style='height:150px'/>`).insertAfter('.text-editor-toolbar')
        $(".text-editor-inner-container").addClass("uploaderActive");
      }

      dispatch({ type: "CONVERSATION_FILE_INSERTED", bool: true })
    }
  }

  async onFileSelect() {
    const { dispatch, conversations, confirmUploadErrorModal } = this.props
    let items = this.filesToItems(this.fileInput.files);
    const files = [...conversations.files, ...items]
    const validFiles = this.filterFiles(files);

    if (files.length !== validFiles.length) {
      await confirmUploadErrorModal();
    }

    dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: validFiles });
    this.fileInput.value = ''
  }

  updateFileUploadStatus(index, data) {
    const { conversations, dispatch } = this.props
    const newItems = conversations.files;
    newItems[index] = Object.assign({}, conversations.files[index], { ...data });
    dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: newItems })
  }

  filterFiles(files) {
    return files.filter((file) => !file.error);
  }

  async handleDrops() {
    const { conversations, dispatch, confirmUploadErrorModal } = this.props
    let items = this.filesToItems(conversations.rawFiles);
    const files = [...conversations.files, ...items]
    const validFiles = this.filterFiles(files);

    if (files.length !== validFiles.length) {
      await confirmUploadErrorModal();
    }

    fromDrag = conversations.loc;
    dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: validFiles })
    dispatch({ type: "CONVERSATION_UPLOADED_RAW", raw: [] })
  }

  async onDrop(e) {
    if (!e) {
      return;
    }
    e.preventDefault();
    this.activeDrag = 0;
    const droppedFiles = e.dataTransfer ? e.dataTransfer.files : [];
    let items = this.filesToItems(droppedFiles);
    items = [...this.state.items, ...items]

    const validFiles = this.filterFiles(items);

    if (items.length !== validFiles.length) {
      await confirmUploadErrorModal();
    }

    this.setState({ isActive: false, items: validFiles, completed: false }, () => {
      if (this.props.auto) {
        this.upload();
      }
    });
  }
  filesToItems(files) {
    const { conversations } = this.props
    const fileItems = Array.prototype.slice.call(files).slice(0, this.props.maxFiles);
    const sorted = fileItems.sort((a, b) => a.size - b.size)
    console.log("sorted", sorted)
    let index = conversations.files.length
    const items = sorted.map((f) => {
      if (this.props.chunks) {
        const chunkProgress = [];
        for (let j = 0; j <= f.size / this.props.chunkSize; j += 1) {
          chunkProgress.push(0);
        }
        return { file: f, index: index++, progress: 0, cancelled: false, chunkProgress, remaining: 0, doc: {}, replace: false, msg: "", error: false };
      }
      let item = { file: f, index: index++, progress: 0, cancelled: false, remaining: 0, doc: {}, replace: false, msg: "", error: false };
      item = this.checkFileSupported(item)
      if (!item.msg) {
        item = this.handleMaxFileSize(item)
      }

      return item;
    });
    totalSize = 0
    return items;
  }

  handleMaxFileSize(item) {
    let max = maxFileSize();
    let fileSize = item.file.size || 0
    let isExceed = fileSize > max
    totalSize += fileSize
    let isExceedTotalSize = totalSize > max

    if (isExceed && item.index === 0) {
      item.error = true;
      item.msg = "File is more than 25mb"
      // showToast('error',`File size exceeds ${Math.floor(max/(1024*1024))} Mb ` )

    } else if (isExceedTotalSize) {
      item.error = true;
      item.msg = `Batch File is more than ${Math.floor(max / (1024 * 1024))}mb`
      //showToast('error',`Batch file size exceeds ${Math.floor(max/(1024*1024))} Mb ` )

    }
    return item
  }

  checkFileSupported(item) {
    let file = item.file
    let fileExtension = file.name.split('.').pop();
    let index = this.props.accept.split(',').indexOf('.' + fileExtension.toLowerCase())
    if (index < 0) {
      item.error = true;
      item.msg = "Invalid File Format"
    }
    return item
  }

  upload() {
    const { conversations, confirmUploadErrorModal, dispatch } = this.props
    const { files } = conversations;
    const list = files.filter(item => !item.cancelled && item.progress === 0)
    const uploadedItems = files.filter(item => !item.cancelled && item.progress === 0 && item.isUploaded)

    const promises = [];

    dispatch({ type: 'SET_SCREEN_LOADER', Loading: true });

    if (uploadedItems.length === list.length) { // some files are already uploaded
      this.props.onFinishUpload();
      return;
    }

    const itemsToUpload = files.filter(item => !item.cancelled && item.progress === 0 && !item.isUploaded);
    itemsToUpload.forEach(item => {
      promises.push(this.uploadItem(item));
    });
    Promise.allSettled(promises)
      .then(async (values) => {
        const fulfilled = values.filter((value) => value.status === 'fulfilled');

        if (itemsToUpload.length === fulfilled.length) {
          this.props.onFinishUpload();
        } else {
          dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
          await confirmUploadErrorModal();
        }
      });
  }

  renderInput() {
    const maxFiles = this.props.maxFiles;
    const accept = this.props.accept;
    const id = this.props.id || 'upload'
    return (
      <a class="image-upload" onClick={() => { this.fileInput.click() }}>
        <i class="material-icons">attach_file</i>

        <input id={`${id}`} style={{ display: "none" }}
          multiple={maxFiles > 1}
          accept={accept}
          type="file"
          ref={c => {
            if (c) {
              this.fileInput = c;
            }
          }}
          onChange={this.onFileSelect}
        />
      </a>
    );
  }

  uploadItem(item) {
    if (this.props.chunks && item.file) {
      const BYTES_PER_CHUNK = this.props.chunkSize;
      const SIZE = item.file.size;

      let start = 0;
      let end = BYTES_PER_CHUNK;

      const chunkProgressHandler = (percentage, chunkIndex) => {
        this.updateFileChunkProgress(item.index, chunkIndex, percentage);
      };
      let chunkIndex = 0;
      while (start < SIZE) {
        this.uploadChunk(item.file.slice(start, end), (chunkIndex += 1), item.file.name, chunkProgressHandler);
        start = end;
        end = start + BYTES_PER_CHUNK;
      }
    } else {
      return this.uploadFile(item, data => this.updateFileUploadStatus(item.index, data));
    }
  }
  setIndex(index) {
    const { dispatch } = this.props
    dispatch({ type: "CONVERSATION_UPLOAD_ACTIVE_INDEX", index: index })
    $('#upload-cancel').modal('show')
  }


  cancelAllUpload() {
    const { dispatch } = this.props
    // const newItems = conversations.files;
    // let counter = 0
    // if (cxhrs.length) {
    //   newItems.map(item => {
    //     const index = item.index
    //     if (index > -1) {
    //       this.executeCancel(index)
    //       newItems[index] = Object.assign({}, conversations.files[index], { cancelled: true, progress: 0, msg: "Upload cancelled" });
    //       dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: newItems })
    //       counter++
    //       if (counter >= newItems.length) {
    //         dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: [] })
    //         dispatch({ type: "CONVERSATION_TOBE_CLEAR"}) 
    //         cxhrs.length=0
    //       }
    //     }

    //   })
    // this.executeCancel(index)
    dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: [] })
    dispatch({ type: "CONVERSATION_TOBE_CLEAR" })
  }

  cancelFile() {
    const { conversations, dispatch } = this.props
    const newItems = conversations.files;
    const index = conversations.uploadActiveIndex
    this.executeCancel(index)
    newItems[index] = Object.assign({}, conversations.files[index], { cancelled: true, progress: 0, msg: "Upload cancelled" });
    dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: newItems })
    const activeLen = newItems.filter(f => !f.cancelled)
    if (activeLen.length === 0) {
      $('.insert_upload').remove()
      $(".conversation-modal .conversation-list.hasScroll").css("max-height", "calc(100vh - 500px)")
      dispatch({ type: "CONVERSATION_FILE_INSERTED", bool: false })
    }
    this.props.onDelete(newItems[index].doc)
    dispatch({ type: "CONVERSATION_UPLOAD_ACTIVE_INDEX", index: -1 })
  }

  executeCancel(index) {
    if (index > -1) {
      if (cxhrs[index]) {
        cxhrs[index].upload.removeEventListener('progress', () => { console.log("remove") });
        cxhrs[index].removeEventListener('load', () => { console.log("remove") });
        cxhrs[index].abort();
      }
    }
  }

  uploadFile(item, progressCallback) {
    let file = item.file;

    if (file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        const xhr = new XMLHttpRequest();
        formData.append("file", file);
        let started_at = new Date();

        xhr.onload = (e) => {
          if (e.target.status === 200) {
            const resp = JSON.parse(xhr.response);
            const data = {
              isUploaded: true,
              doc: resp.result[0]
            }
            progressCallback(data);
            if (this.props.onUpload) {
              this.props.onUpload(resp.result[0])
            }
            resolve(item);
          } else {
            reject(xhr);
          }
        };

        progressCallback({ id: 0, isUploaded: false });
        xhr.open(this.props.method, this.props.url, true);
        xhr.send(formData);
        cxhrs[item.index] = xhr;
      });
    }
  }
  renderFileSet() {
    const { conversations, screenLoader } = this.props
    const items = conversations.files
    let activeItem = items.filter(e => {
      return e.cancelled == false
    })

    if (items.length > 0 && activeItem.length > 0) {
      const { styles } = this.state;
      const addstyle = {
        position: 'absolute',
        // top: -179,
        bottom: 55,
        left: -600,
        width: 723
      }
      const filesetStyle = { ...styles.fileset, ...addstyle };
      return (
        <div class="uploadMainContainer" id="uploadFilesContainer" style={filesetStyle}>
          {items.filter(item => !item.cancelled && !!item.file).map(item => {

            const file = item.file;
            return (
              <div key={item.index} class="commentAttachItem pd15 pb0">
                <div class="commentAttachItemContainer">
                  <div class="fileDetailsWrapper">
                    <i class={`material-icons mr5 text-size22 text-black`}>description</i>
                    <span class={`text-black`} >{`${file.name.length > 25 ? file.name.substr(0, 25) + "..." : file.name}`}</span>
                  </div>
                  {screenLoader.Loading && item.isUploaded ?
                    (<i class="material-icons ml10" style={{ fontSize: 20, color: "#16DC38" }}>check</i>)
                    :
                    (<span onClick={() => { this.setIndex(item.index) }}>
                      <i class="material-icons ml10" style={{ fontSize: 20, color: "#D34A46 !important" }}>close</i>
                    </span>
                    )
                  }
                </div>
              </div>
            );
          })}

        </div>

      );
    }
  }

  renderDropTarget() {
    const { uploadIconClass } = this.props;
    const { styles } = this.state;
    let dropTargetStyle = styles.dropTargetStyle;
    if (this.state.isActive) {
      dropTargetStyle = Object.assign({}, dropTargetStyle, styles.dropTargetActiveStyle);
    }
    return (
      <div
        data-test-id="dropTarget"
        style={dropTargetStyle}
        onClick={this.onClick}
        onDragEnter={this.onDragEnter}
        onDragOver={this.onDragOver}
        onDragLeave={this.onDragLeave}
        onDrop={this.onDrop}
      >
        <div style={styles.placeHolderStyle}>
          <p>{this.props.dropzoneLabel}</p>
        </div>


      </div>
    );
  }

  render() {
    const styles = {
      root: {
        padding: 0
      }
    }
    const isHide = this.props.hide
    let id = this.props.id ? this.props.id : "upload"
    return (
      <>
        <div class="toolbar-buttons upload-buttons" style={styles.root}>
          <span style={{ display: `${isHide ? 'none' : 'in-line'}` }}>
            {this.renderDropTarget()}
            {this.renderButton()}
          </span>

          <span class="uploadRender">
            {this.renderFileSet()}
          </span>

          {this.renderInput()}

          <span id={`${id}`} style={{ display: "none" }} onClick={() => { this.onClick() }}></span>
          <span id={`${id}-clear`} style={{ display: "none" }} onClick={() => { this.clearFile() }}></span>
          <span id={`${id}-droppedFiles`} style={{ display: "none" }} onClick={() => { this.handleDrops() }}></span>
          <span id={`${id}-upload`} style={{ display: "none" }} onClick={() => { this.upload() }}></span>
          <span id={`${id}-cancel`} style={{ display: "none" }} onClick={() => { this.cancelFile() }}></span>
          <span id={`${id}-cancelAll`} style={{ display: "none" }} onClick={() => { this.cancelAllUpload() }}></span>
        </div>
        <ModalPortal>
          <this.props.uploadErrorModal />
        </ModalPortal>
      </>
    );
  }
}

function withConfirmationModal(Component) {
  return function WrappedCommentUploader(props) {
    const [uploadErrorModal, confirmUploadErrorModal] = useConfirmPopup({
      title: 'Unabled to attach file/s',
      message: <div className='tw-flex tw-flex-col tw-gap-3'>
        <span>Your file/s failed to attach may be due to the following: </span>
        <div>
          <p>1. Your file/s exceeded the maximum file size of 25 MB.</p>
          <p>2. Only the following file formats can be attached: .jpg, .png, .pdf, .doc, .docx, .xlsx, .pptx, .ppt, .xls, .csv.</p>
        </div>
      </div>,
      cancelBtn: {
        label: 'Okay'
      },
      confirmBtn: false,
      icon: {
        icon: ICONS.error,
        iconType: ICON_TYPES.outlined,
        className: 'tw-text-cfo-red-400 tw-text-[22px] tw-font-medium',
      },
      modalId: 'conversation-upload-modal',
      modalType: MODAL_TYPE.danger,
      actionPosition: ACTION_POSITIONS.end
    })

    return (
      <Component {...props}
        uploadErrorModal={uploadErrorModal}
        confirmUploadErrorModal={confirmUploadErrorModal}
      />
    )
  }
}

export default withConfirmationModal(CommentUploader)